module.exports = __webpack_public_path__ + "img/p4_3.57eb5d9d.png";